export const container = {
	// you can configure the container to be centered
	center: true,

	// or have default horizontal padding
	padding: '12px',

	// default breakpoints but with 40px removed
	screens: {
		sm: '600px',
		md: '728px',
		lg: '984px',
		xl: '1170px',
		'2xl': '1440px',
	},
};

export const colors = {
	white: '#ffffff',
	bittersweet: '#F36F63',
	default: '#F36F63',
	mauvelous: '#FFEBEA',
	gray: '#999999',
	silver: '#F2F2F2',

	black: { 1: '#282828', DEFAULT: '#000000' },

	blue: {
		alice: '#EAF4FF',
		ocean: '#0784A0',
		DEFAULT: '#2639ED',
	},

	green: {
		light: '#ECFFED',
		DEFAULT: '#2AB644',
	},

	yellow: {
		light: '#FFF8EC',
		DEFAULT: '#FF9900',
	},

	red: {
		light: '#FFF4F4',
		DEFAULT: '#FF3939',
	},

	pink: {
		yellow: '#FF3A6E',
		DEFAULT: '#F7658B',
	},

	border: 'hsl(var(--border))',
	input: 'hsl(var(--input))',
	ring: 'hsl(var(--ring))',
	background: 'hsl(var(--background))',
	foreground: 'hsl(var(--foreground))',
	secondary: {
		DEFAULT: 'hsl(var(--secondary))',
		foreground: 'hsl(var(--secondary-foreground))',
	},
	destructive: {
		DEFAULT: 'hsl(var(--destructive))',
		foreground: 'hsl(var(--destructive-foreground))',
	},
	muted: {
		DEFAULT: 'hsl(var(--muted))',
		foreground: 'hsl(var(--muted-foreground))',
	},
	accent: {
		DEFAULT: 'hsl(var(--accent))',
		foreground: 'hsl(var(--accent-foreground))',
	},
	popover: {
		DEFAULT: 'hsl(var(--popover))',
		foreground: 'hsl(var(--popover-foreground))',
	},
	card: {
		DEFAULT: 'hsl(var(--card))',
		foreground: 'hsl(var(--card-foreground))',
	},
};

export const fontSize = {
	12: '12px',
	14: '14px',
	15: '15px',
};

export const fontFamily = {
	fzPoppins: ['var(--fzPoppins-font)', 'sans-serif'],
};

export const boxShadow = {
	'1': '0px 0px 24px 0px rgba(155, 155, 155, 0.25)',
	'2': '0px 10px 50px 0px rgba(0, 0, 0, 0.10)',
	'3': '0px 4px 24px 0px rgba(95, 22, 0, 0.10)',
};

export const keyframes = {
	'accordion-down': {
		from: { height: '0' },
		to: { height: 'var(--radix-accordion-content-height)' },
	},
	'accordion-up': {
		from: { height: 'var(--radix-accordion-content-height)' },
		to: { height: '0' },
	},
};

export const animation = {
	'accordion-down': 'accordion-down 0.2s ease-out',
	'accordion-up': 'accordion-up 0.2s ease-out',
};

export const backgroundImage = {
	'pink-to-yellow': 'linear-gradient(90deg, #FF3A6E 0%, #FFAE00 99.79%)',
	'gradient-main':
		'linear-gradient(180deg, rgba(243, 111, 99, 0.00) 0%, #F36F63 100%)',
	'gradient-black':
		'linear-gradient(90deg, rgba(40, 40, 40, 0.80) 46.6%, rgba(0, 0, 0, 0.16) 99.92%)',
};

export const theme = {
	transparent: 'transparent',
	extend: {
		container,
		colors,
		fontSize,
		fontFamily,
		boxShadow,
		keyframes,
		animation,
		backgroundImage,
	},
};
